import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import FloatInventoryStockDetails from "../../../components/float-engine-dashboard/inventory-stock-details";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import StockDetailsWrtPlantAndListNumber from "../../../components/float-engine-dashboard/stock-details-wrt-plant-and-list";
import RepairedDefectiveStatus from "../../../components/float-engine-dashboard/repaired-defective-status";
import FloatInventoryTrend from "../../../components/float-engine-dashboard/float-inventory-trend";
import { FINANCIAL_YEAR } from "../../../core/india-map/utils";
import DaysToDispatchEngine from "../../../components/float-engine-dashboard/days-to-dispatch-engine";
import StateWiseDispatchedReport from "../../../components/float-engine-dashboard/state-wise-dispatched-report";

const TABS = {
  COUNT: "count",
  COST: "cost",
};

const FloatEngineDashboard = () => {
  const [tab, setTab] = useState(TABS.COUNT);
  const [inventoryStockDetails, setInventoryStockDetails] = useState({});
  const [StockDetailsWrtPlantAndList, setStockDetailsWrtPlantAndList] =
    useState({});
  const [repairedDefectiveStatus, setRepairedDefectiveStatus] = useState({});
  const [loading, setLoading] = useState(false);
  const [floatInventoryTrend, setFloatInventoryTrend] = useState([]);
  const [financialYearFilter, setFinancialYearFilter] = useState("");
  const [daysToDispatchEngine, setDaysToDispatchEngine] = useState({});
  const [stateWiseDispatchReport, setStateWiseDispatchReport] = useState({});
  const financialYearList = FINANCIAL_YEAR;

  const loadInventoryStockDetails = (type) => {
    const url =
      type === TABS.COST
        ? `${HOSTNAME}${REST_URLS.FLOAT_INVENTORY_COST_DETAILS}`
        : `${HOSTNAME}${REST_URLS.FLOAT_INVENTORY_STOCK_DETAILS}`;

    setLoading(true);
    invokeApi(HTTP_METHODS.GET, url)
      .then((res) => {
        if (!res.message) {
          setInventoryStockDetails(res);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };
  const loadStockDetailsWrtPlantAndList = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STOCK_DETAILS_WRT_PLANT_AND_LIST}`
    )
      .then((res) => {
        if (!res.message) {
          setStockDetailsWrtPlantAndList(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadRepairedAndDefectiveStatus = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.REPAIRED_AND_DEFECTIVE_STATUS}`
    )
      .then((res) => {
        if (!res.message) {
          setRepairedDefectiveStatus(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadFloatInventoryTrend = (params) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.FLOAT_INVENTORY_TREND}`,
      null,
      params
    )
      .then((res) => {
        if (!res.message) {
          setFloatInventoryTrend(res);
        }
      })
      .catch((err) => console.log(err));
  };
  const loadDaysToDispatchEngine = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.DAYS_TO_DISPATCH_ENGINE}`
    )
      .then((res) => {
        if (!res.message) {
          setDaysToDispatchEngine(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadStateWiseDispatchedReport = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STATE_WISE_DISPATCH_REPORT}`
    )
      .then((res) => {
        if (!res.message) {
          setStateWiseDispatchReport(res);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadInventoryStockDetails(tab);
  }, [tab]);
  useEffect(() => {
    loadStockDetailsWrtPlantAndList();
    loadRepairedAndDefectiveStatus();
    loadDaysToDispatchEngine();
    loadStateWiseDispatchedReport();
  }, []);
  useEffect(() => {
    const defaultFY = financialYearList?.[0]?.value;
    if (defaultFY) setFinancialYearFilter(defaultFY);
  }, []);

  useEffect(() => {
    if (financialYearFilter) {
      loadFloatInventoryTrend({
        financialYear: financialYearFilter,
      });
    }
  }, [financialYearFilter]);
  return (
    <Box sx={{ p: 3 }}>
      <Typography sx={{ textAlign: "center", mb: 2 }} variant="h5">
        FLOAT ENGINE DASHBOARD
      </Typography>
      <Card>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6" sx={{ mb: 2 }} className="primary-text">
              FLOAT INVENTORY STOCK DETAILS
            </Typography>

            <ToggleButtonGroup
              value={tab}
              exclusive
              onChange={(e, newVal) => {
                if (newVal !== null) setTab(newVal);
              }}
              size="small"
            >
              <ToggleButton value={TABS.COUNT}>Count</ToggleButton>
              <ToggleButton value={TABS.COST}>Cost</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {loading ? (
            <Box textAlign="center" py={4}>
              <CircularProgress />
            </Box>
          ) : (
            <FloatInventoryStockDetails
              data={inventoryStockDetails}
              type={tab}
            />
          )}
        </CardContent>
      </Card>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Card sx={{ mt: 2, minHeight: "100%" }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }} className="primary-text">
                Float Inventory Trend
              </Typography>
              <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <InputLabel>Financial Year</InputLabel>
                  <Select
                    label="Financial Year"
                    value={financialYearFilter}
                    onChange={(e) => setFinancialYearFilter(e.target.value)}
                  >
                    {financialYearList.map((fy) => (
                      <MenuItem key={fy.value} value={fy.value}>
                        {fy.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <FloatInventoryTrend data={floatInventoryTrend} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={6}>
          <Card sx={{ mt: 2, minHeight: "100%" }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }} className="primary-text">
                No of Days took to dispatch Float Engines to Field
              </Typography>
              <DaysToDispatchEngine data={daysToDispatchEngine} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Card sx={{ mt: 7 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }} className="primary-text">
            Float Engine- Repaired / Defective Status
          </Typography>
          <RepairedDefectiveStatus data={repairedDefectiveStatus} />
        </CardContent>
      </Card>
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }} className="primary-text">
            Float Engine Stock details with respect to Plant and List number
          </Typography>
          <StockDetailsWrtPlantAndListNumber
            data={StockDetailsWrtPlantAndList}
          />
        </CardContent>
      </Card>
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }} className="primary-text">
            No. of Days took to dispatch the Complaint engine from Field
          </Typography>
          <StateWiseDispatchedReport data={stateWiseDispatchReport} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default FloatEngineDashboard;
